// extracted by mini-css-extract-plugin
export default {"Addressee":"styles_Addressee__7OTBH","removeIcon":"styles_removeIcon__RLqPi"};